import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { AlertTriangle, ChevronRight } from "lucide-react";

export const RefillBanner = () => {
  const q = useQuery({
    queryKey: ["supplies-status"],
    queryFn: async () => (await api.get("/supplies/status")).data,
    refetchInterval: 120000,
  });
  if (!q.data?.needs_refill) return null;
  const { red, yellow, names } = q.data;

  return (
    <Link
      to="/admin/materiale"
      className="block bg-red-600 text-white px-4 py-2.5 hover:bg-red-700 transition-colors"
      data-testid="refill-banner"
    >
      <div className="max-w-5xl mx-auto flex items-center gap-2">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span className="font-black tracking-tight text-sm shrink-0">Refill spesa Magazzino</span>
        <span className="text-xs text-white/85 truncate">
          {red} in urgenza · {yellow} in pericolo — {(names || []).join(", ")}
        </span>
        <ChevronRight className="w-4 h-4 ml-auto shrink-0" />
      </div>
    </Link>
  );
};
